import {Injectable} from '@angular/core';
import {LicenseFeaturesService} from '../../../../services/common/license-features/license-features.service';
import {UserPrivilegeService} from '../../../../services/common/user-privilege/user-privilege.service';
import {DataItemToVisualsMappersService} from '../data-item-to-visuals-mappers/data-item-to-visuals-mappers.service';
import {OnlineNodeService} from '../../online/node/online-node.service';
import {OnlineNetworkService} from '../../online/network/online-network.service';
import {OnlineVoipPeerService} from '../../online/voip-peer/online-voip-peer.service';
import {OnlineConnectionService} from '../../online/connection/online-connection.service';
import {OnlinePeerConnectionService} from '../../online/peer-connection/online-peer-connection.service';
import {PeerConnectionApiService} from '../../../../services/api/peer-connection/peer-connection-api.service';
import {OneTimeConfirmationDialogService} from '../../../../dialogs/one-time-confirmation-dialog/service/one-time-confirmation-dialog.service';
import {MapService} from '../map/map.service';

@Injectable({
  providedIn: 'root'
})
export class DiagramContextMenuService {

  constructor(private oneTimeConfirmationDialogService: OneTimeConfirmationDialogService,
              private nodeService: OnlineNodeService,
              private networkService: OnlineNetworkService,
              private voipPeerService: OnlineVoipPeerService,
              private connectionService: OnlineConnectionService,
              private pConService: OnlinePeerConnectionService,
              private licenseFeaturesService: LicenseFeaturesService,
              private peerConnectionsApiService: PeerConnectionApiService,
              private dataItemToVisualsMappersService: DataItemToVisualsMappersService,
              private userPrivilege: UserPrivilegeService,
              private mapService: MapService) {
  }

  prepareContextMenuActions(diagramApi, clickedElement): any {
    let actionsObject;
    const diagramElement = clickedElement;

    const updateActionsSupport = () => {

      this.licenseFeaturesService.isFeatureSupported('testRoute').subscribe(isFeatureSupported => {
        actionsObject.peerConnection.some(action => {
          if (action.actionName === 'testRoute') {
            action.visible = isFeatureSupported;
          }
          return action.actionName === 'testRoute';
        });

        actionsObject.virtualPCon.some(action => {
          if (action.actionName === 'testRoute') {
            action.visible = isFeatureSupported;
          }
          return action.actionName === 'testRoute';
        });
      });

      if (diagramElement.shapeType === 'node') {
        if (diagramElement.dataItem.productType !== 'THIRD_PARTY') {
          actionsObject.currentElement = 'node';
          updateNodeActionsSupport();
        } else {
          actionsObject.currentElement = 'thirdPartyNode';
          updateThirdPartyActionsSupport();
        }
      } else if (diagramElement.shapeType === 'voipPeer') {
        actionsObject.currentElement = 'voipPeer';
        updateVoipPeerActionsSupport();
      } else if (diagramElement.shapeType === 'cluster') {
        actionsObject.currentElement = 'cluster';
        // no actions to check
      } else if (diagramElement.connectionType === 'connection') {
        actionsObject.currentElement = 'connection';
        // no actions to check
      } else if (diagramElement.connectionType === 'peerConnection') {
        if (diagramElement.dataItem.peerConnectionNodeType === 'Virtual') {
          actionsObject.currentElement = 'virtualPCon';
          updateVirtualPConActionsSupport();
        } else {
          actionsObject.currentElement = 'peerConnection';
          updatePConActionsSupport();
        }
      } else if (diagramElement.connectionType === 'cluster') {
        actionsObject.currentElement = 'edgesCluster';
      }
    };

    const updateNodeActionsSupport = () => {
      actionsObject.node.some((action, i) => {
        if (action.actionName === 'lockNode') {
          action.visible = isLockEnabled();
          actionsObject.node[i + 1].visible = action.visible;
          return action.actionName === 'lockNode';
        }
      });
      actionsObject.node.some((action, i) => {
        if (action.actionName === 'unlockNode') {
          action.visible = isUnlockEnabled();
          actionsObject.node[i + 1].visible = action.visible;
          return action.actionName === 'unlockNode';
        }
      });
      actionsObject.node.some((action, i) => {
        if (action.actionName === 'deleteNode') {
          action.visible = isUnlockEnabled();
          actionsObject.node[i + 1].visible = action.visible;
          return action.actionName === 'deleteNode';
        }
      });
      actionsObject.node.some((action, i) => {
        if (action.actionName === 'collapseNode') {
          action.visible = isNodeCollapsible();
          actionsObject.node[i + 1].visible = action.visible;
          return action.actionName === 'collapseNode';
        }
      });
      actionsObject.node.some((action, i) => {
        if (action.actionName === 'saveIniFile') {
          return action.actionName === 'saveIniFile';
        }
      });
    };

    const updateThirdPartyActionsSupport = () => {
      actionsObject.thirdPartyNode.some((action, i) => {
        if (action.actionName === 'lockNode') {
          action.visible = isLockEnabled();
          actionsObject.thirdPartyNode[i + 1].visible = action.visible;
          return action.actionName === 'lockNode';
        }
      });
      actionsObject.thirdPartyNode.some((action, i) => {
        if (action.actionName === 'unlockNode') {
          action.visible = isUnlockEnabled();
          actionsObject.thirdPartyNode[i + 1].visible = action.visible;
          return action.actionName === 'unlockNode';
        }
      });
      actionsObject.thirdPartyNode.some((action, i) => {
        if (action.actionName === 'deleteNode') {
          action.visible = isUnlockEnabled();
          actionsObject.thirdPartyNode[i + 1].visible = action.visible;
          return action.actionName === 'deleteNode';
        }
      });
      actionsObject.thirdPartyNode.some((action, i) => {
        if (action.actionName === 'collapseNode') {
          action.visible = isNodeCollapsible();
          actionsObject.thirdPartyNode[i + 1].visible = action.visible;
          return action.actionName === 'collapseNode';
        }
      });
    };

    const isNodeCollapsible = () => {
      let pCons;
      let connectedToNodepCons;
      let connectedToNodeVoipPeersIds;
      let notClusteredVoipPeers;

      pCons = diagramApi.getData().edgesArray.filter(shape => shape.connectionType === 'peerConnection');

      connectedToNodepCons = pCons.filter(pCon => pCon.dataItem.nodeId === diagramElement.dataItem.id);

      connectedToNodeVoipPeersIds = connectedToNodepCons.map(pCon => 'voippeer_' + pCon.dataItem.voipPeerId);

      notClusteredVoipPeers = connectedToNodeVoipPeersIds.filter(voipPeerId => diagramApi.findNode(voipPeerId).length === 1);

      return notClusteredVoipPeers.length > 1;
    };


    // actions

    const configureNode = () => {
      this.nodeService.configureNode(diagramElement.dataItem);
    };

    const editNode = () => {
      if (diagramElement.dataItem.productType === 'THIRD_PARTY') {
        this.nodeService.editThirdPartyDevice(diagramElement.dataItem);
      } else {
        this.nodeService.editNode(diagramElement.dataItem);
      }
    };

    const addConnection = () => {
      if (diagramElement.dataItem.productType !== 'THIRD_PARTY') {
        this.connectionService.addConnection(diagramElement.dataItem.id);
      } else {
        this.connectionService.addConnection(undefined, diagramElement.dataItem.id);
      }
    };

    const syncNode = () => {
      this.nodeService.syncNode(diagramElement.dataItem.id);
    };

    const lockNode = () => {
      this.nodeService.lockNode(diagramElement.dataItem.id);
    };

    const unlockNode = () => {
      this.nodeService.unlockNode(diagramElement.dataItem.id);
    };

    const deleteNode = () => {
      this.nodeService.deleteNode(diagramElement.dataItem);
    };

    const saveIniFile = () => {
      this.nodeService.saveIniFile(diagramElement.dataItem);
    };

    const addPCon = () => {
      this.pConService.addVirtualPCon(diagramElement.dataItem, null);
    };

    const editVoipPeer = () => {
      this.voipPeerService.editVoipPeer(diagramElement.dataItem);
    };

    const deleteVoipPeer = () => {
      this.voipPeerService.deleteVoipPeer(diagramElement.dataItem);
    };

    const editConnection = () => {
      this.connectionService.editConnection(diagramElement.dataItem.id);
    };

    const deleteConnection = () => {
      this.connectionService.deleteConnection(diagramElement.dataItem);
    };

    const dragConnection = () => {
      this.oneTimeConfirmationDialogService.showPopup('DragConnectionExplanation',
        'Click and drag the mouse from one element to the other.',
        () => {
          diagramApi.addEdgeMode();
        });
    };

    const editPCon = () => {
      this.pConService.editPcon(diagramElement.dataItem.id);
    };

    const deletePCon = () => {
      this.pConService.deletePcon(diagramElement.dataItem);
    };

    const lockPCon = () => {
      console.log('locked!!!!');
      this.pConService.lockPcon(diagramElement.dataItem.id);
    };

    const lockOutgoingPCon = () => {
      this.peerConnectionsApiService.lockOutgoingPCon(diagramElement.dataItem.id).then(() => {
        this.refreshDiagram();
      }).catch(() => {});
    };

    const unlockPCon = () => {
      console.log('unlocked!!!!');
      this.pConService.unlockPcon(diagramElement.dataItem.id);
    };

    const detachPCon = () => {
      this.pConService.detachPCon(diagramElement.dataItem.id);
    };

    const testRoute = () => {
      this.pConService.testRoute(diagramElement.dataItem.id);
    };

    const editVirtualPCon = () => {
      this.pConService.editVirtualPCon(diagramElement.dataItem.id);
    };

    const editCluster = () => {
      const onSuccess = (cluster) => {
        const clusterLabel = this.dataItemToVisualsMappersService.prepareLabelForDiagram(cluster.name);
        diagramApi.updateCluster(cluster.id, cluster.name, clusterLabel);
      };
      this.networkService.editCluster(diagramElement, onSuccess);
    };

    function collapseNode(): void {
      diagramApi.createCluster(diagramElement.id, 'voipPeer', 'cluster');
    }

    function clusterSelectedVoipPeers(): void {
      const selectedVoipPeers = diagramApi.getShapeSelection().filter(selectedShape => selectedShape.shapeType === 'voipPeer');

      const selectedVoipPeersIds = selectedVoipPeers.map(voipPeer => voipPeer.id);

      diagramApi.clusterByIds(selectedVoipPeersIds, 'cluster');
    }

    function addToCluster(): void {
      const selectedVoipPeers = diagramApi.getShapeSelection()
        .filter(selectedShape => selectedShape.shapeType === 'voipPeer').map(voipPeer => voipPeer.id);

      const selectedCluster = diagramApi.getShapeSelection().find(selectedShape => selectedShape.shapeType === 'cluster');

      diagramApi.addNodesToCluster(selectedCluster.id, selectedVoipPeers);
    }

    function expandNode(): void {
      diagramApi.openCluster(diagramElement.id);
    }

    function isLockEnabled(): boolean {
      return diagramElement.dataItem.adminState.toLowerCase() === 'unlocked';
    }

    function isUnlockEnabled(): boolean{
      return diagramElement.dataItem.adminState.toLowerCase() === 'locked' ||
        diagramElement.dataItem.adminState.toLowerCase() === 'locked_incoming' ||
        diagramElement.dataItem.adminState.toLowerCase() === 'locked_outgoing';
    }

    function isDeletePConEnabled(): boolean {
      return diagramElement.dataItem.operState.toLowerCase() === 'predeleted';
    }

    function isDetachPConEnabled(): boolean {
      return !isOnlyOnePConConnected(diagramElement.dataItem);
    }

    function isOnlyOnePConConnected(selectedPCon): boolean {
      const commonPCons = diagramApi.getData().edgesArray
        .filter(edge => edge.connectionType === 'peerConnection' && edge.dataItem.voipPeerId === selectedPCon.voipPeerId);

      return commonPCons.length < 2;
    }

    function isDeleteVoipPeerEnabled(): boolean {
      return !isVoipPeerConnected(diagramElement.dataItem);
    }

    function isClusterSelectedVoipPeersEnabled(): boolean {
      const selectedVoipPeers = diagramApi.getShapeSelection().filter(selectedShape => selectedShape.shapeType === 'voipPeer');

      return selectedVoipPeers.length > 1;
    }

    function isAddToClusterEnabled(): boolean {
      const selectedVoipPeers = diagramApi.getShapeSelection().filter(selectedShape => selectedShape.shapeType === 'voipPeer');

      const selectedClusters = diagramApi.getShapeSelection().filter(selectedShape => selectedShape.shapeType === 'cluster');

      return selectedClusters.length === 1 && selectedVoipPeers.length > 0;
    }

    function isVoipPeerConnected(dataItem): boolean {
      const pConsOfVoipPeer = diagramApi.getData().edgesArray
        .filter(edge => edge.connectionType === 'peerConnection' && edge.dataItem.voipPeerId === dataItem.id);
      return pConsOfVoipPeer.length > 0;
    }

    const updateVoipPeerActionsSupport = () => {
      actionsObject.voipPeer.some((action, i) => {
          if (action.actionName === 'deleteVoipPeer') {
            action.visible = isDeleteVoipPeerEnabled();
            actionsObject.voipPeer[i + 1].visible = action.visible;
            return action.actionName === 'deleteVoipPeer';
          }
        }
      );
      actionsObject.voipPeer.some((action, i) => {
          if (action.actionName === 'clusterSelectedVoipPeers') {
            action.visible = isClusterSelectedVoipPeersEnabled();
            actionsObject.voipPeer[i + 1].visible = action.visible;
            return action.actionName === 'clusterSelectedVoipPeers';
          }
        }
      );
      actionsObject.voipPeer.some((action, i) => {
        if (action.actionName === 'addToCluster') {
          action.visible = isAddToClusterEnabled();
          actionsObject.voipPeer[i + 1].visible = action.visible;
          return action.actionName === 'addToCluster';
        }
      });
    };

    const updatePConActionsSupport = () => {
      actionsObject.peerConnection.some((action, i) => {
        if (action.actionName === 'deletePCon') {
          action.visible = isDeletePConEnabled();
          actionsObject.peerConnection[i + 1].visible = action.visible;
          return action.actionName === 'deletePCon';
        }
      });
      actionsObject.peerConnection.some((action, i) => {
        if (action.actionName === 'unlockPCon') {
          action.disabled = !this.isAuthorizedUser() || isLockEnabled();
          return action.disabled === 'unlockPCon';
        }
      });
      actionsObject.peerConnection.some((action, i) => {
        if (action.actionName === 'detachPCon') {
          action.visible = isDetachPConEnabled();
          actionsObject.peerConnection[i + 1].visible = action.visible;
          return action.actionName === 'detachPCon';
        }
      });
    };

    const updateVirtualPConActionsSupport = () => {
      actionsObject.virtualPCon.some((action, i) => {
        if (action.actionName === 'lockOutgoingPCon') {
          action.visible = !this.isAuthorizedUser() || isLockEnabled();
          actionsObject.virtualPCon[i + 1].visible = action.visible;
          return action.actionName === 'lockOutgoingPCon';
        }
      });
      actionsObject.virtualPCon.some((action, i) => {
        if (action.actionName === 'unlockPCon') {
          action.visible = !this.isAuthorizedUser() || isUnlockEnabled();
          actionsObject.virtualPCon[i + 1].visible = action.visible;
          return action.actionName === 'unlockPCon';
        }
      });
    };


    actionsObject = {
      currentElement: 'node',
      node: [
        {
          actionName: 'dragConnection',
          click: dragConnection,
          visible: true,
          disabled: !this.isAuthorizedUser(),
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-arrow-right fa-lg"></i></div><span>Drag connection</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'addConnection',
          click: addConnection,
          visible: true,
          disabled: !this.isAuthorizedUser(),
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-arrows-h fa-lg"></i></div><span>Add connection</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'configureNode',
          click: configureNode,
          disabled: !this.isAuthorizedUser(),
          visible: true,
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-wrench fa-lg"></i></div><span>Configure</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'editNode',
          click: editNode,
          visible: true,
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-pencil-square-o fa-lg"></i></div><span>Edit</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'syncNode',
          click: syncNode,
          disabled: !this.isAuthorizedUser(),
          visible: true,
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-refresh fa-lg"></i></div><span>Sync node</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'lockNode',
          click: lockNode,
          disabled: !this.isAuthorizedUser(),
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-lock fa-lg"></i></div><span>Lock</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'unlockNode',
          click: unlockNode,
          disabled: !this.isAuthorizedUser(),
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-unlock fa-lg"></i></div><span>Unlock</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'deleteNode',
          click: deleteNode,
          disabled: !this.isAuthorizedUser(),
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-times fa-lg"></i></div><span>Delete</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'collapseNode',
          click: collapseNode,
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-compress fa-lg"></i></div><span>Collapse</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'saveIniFile',
          click: saveIniFile,
          disabled: !this.isAuthorizedUser(),
          visible: true,
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-download fa-lg"></i></div><span>Save INI File</span></div>'
        }
      ],
      thirdPartyNode: [
        {
          actionName: 'dragConnection',
          click: dragConnection,
          visible: true,
          disabled: !this.isAuthorizedUser(),
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-arrow-right fa-lg"></i></div><span>Drag connection</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'dragPeerConnection',
          click: dragConnection,
          disabled: !this.isAuthorizedUser(),
          visible: true,
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-arrow-right fa-lg"></i></div><span>Drag peer connection</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'addConnection',
          click: addConnection,
          disabled: !this.isAuthorizedUser(),
          visible: true,
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-arrows-h fa-lg"></i></div><span>Add connection</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'editNode',
          click: editNode,
          visible: true,
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-pencil-square-o fa-lg"></i></div><span>Edit</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'lockNode',
          click: lockNode,
          disabled: !this.isAuthorizedUser(),
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-lock fa-lg"></i></div><span>Lock</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'unlockNode',
          click: unlockNode,
          disabled: !this.isAuthorizedUser(),
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-unlock fa-lg"></i></div><span>Unlock</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'deleteNode',
          click: deleteNode,
          disabled: !this.isAuthorizedUser(),
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-times fa-lg"></i></div><span>Delete</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'collapseNode',
          click: collapseNode,
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-compress fa-lg"></i></div><span>Collapse</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'addPCon',
          click: addPCon,
          visible: true,
          disabled: !this.isAuthorizedUser(),
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-plus fa-lg"></i></div><span>Add peer connection</span></div>'
        },
        {divider: true, visible: true}
      ],
      voipPeer: [
        {
          actionName: 'editVoipPeer',
          click: editVoipPeer,
          visible: true,
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-pencil-square-o fa-lg"></i></div><span>Edit</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'deleteVoipPeer',
          click: deleteVoipPeer,
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-times fa-lg"></i></div><span>Delete</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'clusterSelectedVoipPeers',
          click: clusterSelectedVoipPeers,
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-compress fa-lg"></i></div><span>Collapse VoIP peers</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'addToCluster',
          click: addToCluster,
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-compress fa-lg"></i></div><span>Add to cluster</span></div>'
        },
        {divider: true, visible: true}
      ],
      connection: [
        {
          actionName: 'editConnection',
          click: editConnection,
          visible: true,
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-pencil-square-o fa-lg"></i></div><span>Edit</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'deleteConnection',
          click: deleteConnection,
          visible: true,
          disabled: !this.isAuthorizedUser(),
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-times fa-lg"></i></div><span>Delete</span></div>'
        },
        {divider: true, visible: true}
      ],
      peerConnection: [
        {
          actionName: 'editPCon',
          click: editPCon,
          visible: true,
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-pencil-square-o fa-lg"></i></div><span>Edit</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'deletePCon',
          click: deletePCon,
          disabled: !this.isAuthorizedUser(),
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-times fa-lg"></i></div><span>Delete</span></div>'
        },
        {divider: true, visible: true},
        {
          subMenu: 'lockSubMenu',
          actionName: 'lockPCon',
          visible: true,
          click: lockPCon,
          disabled: !this.isAuthorizedUser(),
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-lock fa-lg"></i></div><span>Lock</span></div>'
        },
        {
          actionName: 'unlockPCon',
          visible: true,
          click: unlockPCon,
          disabled: !this.isAuthorizedUser(),
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-unlock fa-lg"></i></div><span>Unlock</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'testRoute',
          click: testRoute,
          visible: true,
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-location-arrow fa-lg"></i></div><span>Test route</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'detachPCon',
          click: detachPCon,
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-chain-broken fa-lg"></i></div><span>Detach</span></div>'
        },
        {divider: true, visible: true}
      ],
      virtualPCon: [
        {
          actionName: 'editVirtualPCon',
          click: editVirtualPCon,
          visible: true,
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-pencil-square-o fa-lg"></i></div><span>Edit</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'deletePCon',
          click: deletePCon,
          disabled: !this.isAuthorizedUser(),
          visible: true,
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-times fa-lg"></i></div><span>Delete</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'lockOutgoingPCon',
          click: lockOutgoingPCon,
          disabled: !this.isAuthorizedUser(),
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-lock fa-lg"></i></div><span>Lock Outgoing</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'unlockPCon',
          click: unlockPCon,
          disabled: !this.isAuthorizedUser(),
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-unlock fa-lg"></i></div><span>Unlock</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'testRoute',
          click: testRoute,
          visible: true,
          html: '<div class="diagram-context-menu-item"><i class="fa fa-location-arrow fa-lg"></i>' +
            '<div class="diagram-action-icon"></div><span>Test route</span></div>'
        },
        {divider: true, visible: true}
      ],
      cluster: [
        {
          actionName: 'expandNode',
          click: expandNode,
          visible: true,
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-expand fa-lg"></i></div><span>Expand</span></div>'
        },
        {divider: true, visible: true},
        {
          actionName: 'editCluster',
          click: editCluster,
          visible: true,
          html: '<div class="diagram-context-menu-item"><div class="diagram-action-icon">' +
            '<i class="fa fa-pencil-square-o fa-lg"></i></div><span>Edit</span></div>'
        },
        {divider: true, visible: true}
      ],
      edgesCluster: []
    };

    updateActionsSupport();

    return actionsObject[actionsObject.currentElement];
  }

  prepareLockPeerConnectionSubMenu(clickedElement): any {
    const lockPCon = () => {
      this.peerConnectionsApiService.lockPCon(clickedElement.dataItem.id)
          .then(() => this.refreshDiagram()).catch(() => {});
    };

    const lockIncomingPCon = () => {
      this.peerConnectionsApiService.lockIncomingPCon(clickedElement.dataItem.id)
          .then(() => this.refreshDiagram()).catch(() => {});
    };

    const lockOutgoingPCon = () => {
      this.peerConnectionsApiService.lockOutgoingPCon(clickedElement.dataItem.id)
          .then(() => this.refreshDiagram()).catch(() => {});
    };

    return [
      {
        subMenu: 'lockSubMenu',
        disabled: !this.isAuthorizedUser() || this.isLocked(clickedElement),
        actionName: 'lockPCon',
        visible: true,
        click: lockPCon,
        html: '<span>Lock</span>'
      },
      {
        subMenu: 'unlockSubMenu',
        disabled: !this.isAuthorizedUser() || this.isIncomingLocked(clickedElement),
        actionName: 'unlockPCon',
        visible: true,
        click: lockIncomingPCon,
        html: '<span>Lock Incoming</span>'
      },
      {
        subMenu: 'unlockSubMenu',
        disabled: !this.isAuthorizedUser() || this.isOutgoingLocked(clickedElement),
        actionName: 'unlockPCon',
        visible: true,
        click: lockOutgoingPCon,
        html: '<span>Lock Outgoing</span>'
      }
    ];
  }

  private isAuthorizedUser(): boolean {
    return this.userPrivilege.isAuthorized();
  }

  private isLocked(clickedElement): boolean {
    return clickedElement.dataItem.adminState.toLowerCase() === 'locked';
  }

  private isIncomingLocked(clickedElement): boolean {
    return clickedElement.dataItem.adminState.toLowerCase() === 'locked_incoming';
  }

  private isOutgoingLocked(clickedElement): boolean {
    return clickedElement.dataItem.adminState.toLowerCase() === 'locked_outgoing';
  }

  private refreshDiagram(): void {
    this.mapService.refresh();
  }
}
